import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { AdminLoginInput, AdminLoginResponse } from '@satyanand/shared';
import { apiRequest } from '../../lib/api';
import { setToken } from '../../lib/auth';
import { createPageUrl } from '../../utils';

export function useLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const login = async (data: AdminLoginInput) => {
    setLoading(true);
    setError(null);
    try {
      const res = await apiRequest<AdminLoginResponse>('/admin/auth/login', {
        method: 'POST',
        body: JSON.stringify(data),
      });

      if (res.data?.token) {
        setToken(res.data.token);
        // Using window.location.href to ensure a full recharge of the app state if needed,
        // or navigate directly if the app is SPA-friendly with the new token.
        window.location.href = createPageUrl('Dashboard');
      } else {
        throw new Error('Authentication failed');
      }
    } catch (err: any) {
      // Security: Use a generic error message to prevent account enumeration
      const errorMessage = err.status === 401 
        ? 'Invalid email or password. Please try again.' 
        : (err.message || 'An unexpected error occurred. Please try again later.');
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    login,
    loading,
    error,
  };
}
